























import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import firebase from 'firebase';
import { mapGetters, mapActions } from 'vuex';
import { FirebaseModule } from '@/module/firebase';
import GlobalHeaderContainer from '@/components/Header/container.vue';
import GlobalFooterContainer from '@/components/Footer/container.vue';
import LoadingContainer from '@/components/Loading/container.vue';
import GameSystemContainer from '@/components/CharacterSheets/GameSystem/container.vue';
import ProfileContainer from '@/components/CharacterSheets/Profile/container.vue';
import StatusContainer from '@/components/CharacterSheets/Status/container.vue';
import SkillContainer from '@/components/CharacterSheets/Skill/container.vue';
import OtherContainer from '@/components/CharacterSheets/Other/container.vue';
import BackStoryContainer from '@/components/CharacterSheets/BackStory/container.vue';
import BackStoryModalContainer from '@/components/CharacterSheets/BackStoryModal/container.vue';
import PrivateContainer from '@/components/CharacterSheets/Private/container.vue';
import JobSelectModalContainer from '@/components/CharacterSheets/JobSelectModal/container.vue';
import SkillModalContainer from '@/components/CharacterSheets/SkillModal/container.vue';
import SubmitBtnContainer from '@/components/CharacterSheets/SubmitBtn/container.vue';
interface Skill {
  label: string;
  initial: number;
}

@Component({
  components: {
    GlobalHeaderContainer,
    GlobalFooterContainer,
    LoadingContainer,
    GameSystemContainer,
    ProfileContainer,
    StatusContainer,
    SkillContainer,
    SkillModalContainer,
    OtherContainer,
    BackStoryContainer,
    BackStoryModalContainer,
    PrivateContainer,
    SubmitBtnContainer,
    JobSelectModalContainer,
  },
})
export default class Create extends Vue {
  private btnText: string = '公開';
  private backStoryModal: boolean = false;
  private jobSelectModal: boolean = false;
  private skillModal: boolean = false;
  private isReading: boolean = true;
  private isWriting: boolean = false;
  private firebaseModule = new FirebaseModule();

  @Getter('Charactersheets/getGameSystem') private gamesystem;
  @Getter('Charactersheets/getBackStory') private backStory;
  @Getter('Charactersheets/getOther') private others;
  @Getter('Charactersheets/getProfile') private profiles;
  @Getter('Charactersheets/getSkill') private skills;
  @Getter('Charactersheets/getStatus') private statuses;
  @Getter('Charactersheets/getPrivate') private isPrivate;
  @Getter('Charactersheets/getJobPointFormula') private jobPointFormula;
  @Getter('User/getUser') private user;

  @Action('Charactersheets/updateSkillList') private updateSkillList!: (payload: Skill[]) => void;
  @Action('Charactersheets/initialize') private initialize!: () => void;
  @Action('User/updateUser') private updateUser!: (payload) => void;

  public initialSet() {
    return new Promise((resolve, reject) => {
      this.initialize();
      resolve();
    });
  }

  public async init() {
    await this.firebaseModule.onAuth();
    await this.initialSet();
  }

  public mounted() {
    this.init();
    this.isReading = false;
  }

  public openJobSelectModal() {
    this.jobSelectModal = true;
  }

  public closeJobSelectModal() {
    this.jobSelectModal = false;
  }

  public openBackStoryModal() {
    this.backStoryModal = true;
  }

  public closeBackStoryModal() {
    this.backStoryModal = false;
  }

  public openSkillModal() {
    this.skillModal = true;
  }

  public closeSkillModal() {
    this.skillModal = false;
  }

  public registCharacterSheet() {
    this.isWriting = true;

    if (!this.profiles.name) {
      this.isWriting = false;
      return;
    }

    const ref = firebase
      .firestore()
      .collection('Character')
      .doc();

    firebase
      .firestore()
      .collection('Character')
      .doc(ref.id)
      .set({
        userid: this.user.uid,
        gamesystem: this.gamesystem,
        profile: this.profiles,
        status: this.statuses,
        skill: this.skills,
        other: this.others,
        backStory: this.backStory,
        isPrivate: this.isPrivate,
        jobPointFormula: this.jobPointFormula,
      })
      .then(() => {
        this.$router.push(`/character/${ref.id}`);
      })
      .catch(() => {
        this.isWriting = false;
      });
  }
}
